export const IMAGES = {
  // Home — hero: real, light-filled kitchen looking onto the garden
  hero: "https://images.unsplash.com/photo-1617228069096-4638a7ffc906?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400&auto=format",
  // Home — hero detail: gloved hand with spray bottle on a wooden worktop
  heroDetail: "https://images.unsplash.com/photo-1628177142898-93e36e4e3a50?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400&auto=format",
  // Quote band (every page)
  calmMoment: "https://images.unsplash.com/photo-1761389294347-4e7b17731a5b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400&auto=format",
  // Services
  regularClean: "https://images.unsplash.com/photo-1642505172378-a6f5e5b15580?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400&auto=format",
  oneOffDetail: "https://images.unsplash.com/photo-1619470105741-93d0d50bfed6?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400&auto=format",
  keysHandover: "https://images.unsplash.com/photo-1737442886747-9fb768b96ed2?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400&auto=format",
  guestBed: "https://images.unsplash.com/photo-1766431066492-9bec8410a57b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400&auto=format",
  // Contact
  contactCall: "https://images.unsplash.com/photo-1758522484779-b852d5582d52?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400&auto=format",
};

/** Soro blog widget (loaded on the /blog page only). Enable embedding in the Soro dashboard for it to render. */
export const SORO_EMBED_SRC = "https://app.trysoro.com/api/embed/2f1ad40f-6d91-46a3-9bca-f0672861799e";

export const NAV_LINKS = [
  { name: "Home", path: "/", id: "home" },
  { name: "Our Services", path: "/services", id: "services" },
  { name: "Why Choose Us", path: "/why-choose-us", id: "why-choose-us" },
  { name: "Pricing", path: "/pricing", id: "pricing" },
  { name: "Testimonies", path: "/testimonials", id: "testimonials" },
  { name: "FAQs", path: "/faqs", id: "faqs" },
  { name: "Contact Us", path: "/contact", id: "contact" },
];

export const CONTACT_DETAILS = {
  phone: "07417 318154",
  phoneHref: "tel:+447417318154",
  email: "info@5pointcleaning.co.uk",
  facebook: "Five Point Cleaning",
  facebookUrl: "https://www.facebook.com/profile.php?id=61594517956889",
};

export const WHY_CHOOSE_US = [
  {
    icon: "HeartHandshake",
    title: "Family-run & close-knit",
    text: "We're a small family business, not a large, faceless cleaning company. We care about the people we work for and take pride in building trusted, long-term relationships with our customers.",
  },
  {
    icon: "Award",
    title: "Experienced cleaners",
    text: "Our team has experience across a range of domestic cleaning environments, with a genuine focus on high standards, attention to detail and doing the job properly.",
  },
  {
    icon: "ShieldCheck",
    title: "Fully insured",
    text: "Five Point Cleaning is fully insured, giving you peace of mind that your home and our team are protected while we carry out our services.",
  },
  {
    icon: "BadgeCheck",
    title: "Enhanced DBS checked",
    text: "Every member of our cleaning team is Enhanced DBS checked, giving you additional reassurance when welcoming us into your home.",
  },
  {
    icon: "FlaskConical",
    title: "COSHH certified",
    text: "Our team is COSHH certified, with an understanding of how to safely handle, use and store cleaning products and chemicals.",
  },
  {
    icon: "HandHeart",
    title: "Dementia & Alzheimer's aware",
    text: "We are Dementia and Alzheimer's aware, helping us provide a respectful, patient and considerate service for people living with dementia and their families.",
  },
  {
    icon: "Sparkles",
    title: "Professional products & equipment",
    text: "We provide our own professional cleaning products and equipment, so you don't need to worry about having everything ready for us.",
  },
  {
    icon: "Leaf",
    title: "Respectful, discreet & non-judgemental",
    text: "Your home is your personal space. We treat it, your belongings and your circumstances with respect, discretion and understanding.",
  },
  {
    icon: "Eye",
    title: "Attention to detail",
    text: "We take pride in the little things. Our aim isn't simply to get the job done — it's to leave you walking through your door and thinking, “Ahh, that's better.”",
  },
];

export const FAQS = [
  {
    category: "Your Home",
    q: "Do I need to be at home while you clean?",
    a: "No. You're welcome to be at home, but you don't need to be. We can arrange access by key, lockbox or another agreed method. You can get on with your day while we take care of the cleaning.",
  },
  {
    category: "Our Service",
    q: "Do you bring your own cleaning products and equipment?",
    a: "Yes. We provide our own professional cleaning products and equipment, so there's nothing you need to provide.",
  },
  {
    category: "Trust & Safety",
    q: "Are you insured?",
    a: "Yes. Five Point Cleaning is fully insured for your peace of mind.",
  },
  {
    category: "Trust & Safety",
    q: "Are your cleaners DBS checked?",
    a: "Yes. Every member of our cleaning team is Enhanced DBS checked.",
  },
  {
    category: "Trust & Safety",
    q: "Do you have cleaning qualifications?",
    a: "Our team is COSHH certified and trained in the safe handling, use and storage of cleaning products and chemicals. We are also Dementia and Alzheimer's aware.",
  },
  {
    category: "Our Service",
    q: "Will I get the same cleaner each time?",
    a: "As a small, close-knit team, we aim to provide consistency wherever possible. We'll do our best to keep you familiar with the members of our team who clean your home.",
  },
  {
    category: "Booking & Payment",
    q: "What areas do you clean?",
    a: "We provide domestic and specialist cleaning services across our service area. Contact us with your postcode and we'll confirm whether we cover your location.",
  },
  {
    category: "Booking & Payment",
    q: "How do I book a clean?",
    a: "Simply contact us with your postcode, property type, number of bedrooms and bathrooms, and the type of cleaning you require. We'll provide a personalised quote and discuss your preferred date and frequency.",
  },
  {
    category: "Booking & Payment",
    q: "Do I need to pay a deposit?",
    a: "Yes. A 50% deposit is required to secure your booking. The remaining 50% is payable immediately after the clean by bank transfer or cash.",
  },
  {
    category: "Booking & Payment",
    q: "What happens if I need to cancel?",
    a: "We require at least 24 hours' notice for cancellations. Cancellations made within 24 hours, or appointments where we cannot gain access to the property, will result in the 50% deposit being retained.",
  },
  {
    category: "Your Home",
    q: "What if my home is particularly messy or hasn't been cleaned for a while?",
    a: "That's absolutely fine. There is no judgement here. We understand that life happens. We'll assess what needs doing and, where additional time or work is required beyond the agreed service, we'll discuss this with you beforehand wherever possible.",
  },
  {
    category: "Your Home",
    q: "Can you clean if I have pets?",
    a: "Yes. We are happy to clean homes with pets. Please let us know what pets you have when booking so we can make appropriate arrangements.",
  },
  {
    category: "Our Service",
    q: "Do you offer one-off cleans?",
    a: "Yes. You don't have to commit to regular cleaning. We offer one-off cleans for when you simply need a helping hand.",
  },
  {
    category: "Our Service",
    q: "Do you offer end-of-tenancy cleaning?",
    a: "Yes. Our end-of-tenancy service is a thorough move-out clean, including the oven, fridge/freezer, microwave and inside cupboards.",
  },
  {
    category: "Our Service",
    q: "Do you clean Airbnb and holiday-let properties?",
    a: "Yes. We offer professional turnover cleaning for Airbnb and holiday-let hosts, including bed changes, fresh linen and guest-ready preparation. Regular hosts can also discuss a bespoke cleaning package with us.",
  },
  {
    category: "Our Service",
    q: "Can I request extra services?",
    a: "Yes. We offer a range of add-ons including bed changes, ironing, microwave cleaning and kettle descaling for domestic cleans, alongside additional services for end-of-tenancy and holiday-let properties.",
  },
  {
    category: "Your Home",
    q: "Do I need to tidy before you arrive?",
    a: "No. You don't need to have your home perfectly tidy before we arrive. However, clearing personal belongings from surfaces and floors where possible allows us to clean more thoroughly.",
  },
  {
    category: "Our Service",
    q: "Can I choose what my cleaner focuses on?",
    a: "Yes. When booking, you can let us know which areas or tasks are most important to you. We'll discuss your priorities and make sure your cleaner focuses on them within the time and service agreed. You can also request additional services, subject to availability and any applicable extra charges.",
  },
  {
    category: "Your Home",
    q: "Can you move furniture?",
    a: "We can move lightweight items where it is safe to do so, but we don't move heavy furniture or appliances unless this has been agreed beforehand.",
  },
  {
    category: "Trust & Safety",
    q: "What if I'm not happy with my clean?",
    a: "We want you to be happy with our service. If there is something we've missed, please let us know within 24 hours of the clean and we'll discuss the best way to resolve it.",
  },
];

export const FAQ_CATEGORIES = ["All", "Booking & Payment", "Our Service", "Your Home", "Trust & Safety"];

export const TERMS = [
  {
    title: "Bookings",
    body: "A booking is only confirmed once a 50% deposit has been received. The remaining 50% balance is payable immediately upon completion of the cleaning service by bank transfer or cash. By paying the deposit, you confirm that you have read and agreed to these Terms & Conditions.",
  },
  {
    title: "Cancellation & Rescheduling",
    body: "We require a minimum of 24 hours' notice for cancellations or changes to a booking. Cancellations made with 24 hours or more notice may be rescheduled, subject to availability. Cancellations made with less than 24 hours' notice will result in the 50% deposit being retained. Repeated cancellations or rescheduling may result in future bookings requiring full payment in advance. Exceptional circumstances may be considered on a case-by-case basis.",
  },
  {
    title: "No Access",
    body: "It is the customer's responsibility to ensure that Five Point Cleaning can access the property at the agreed time. If we arrive and cannot gain access, the booking will be treated as a no-access appointment and the 50% deposit will be retained.",
  },
  {
    title: "Cleaning Products & Equipment",
    body: "Five Point Cleaning provides its own cleaning products and equipment unless otherwise agreed. Customers must tell us before the clean about surfaces or items requiring specific products or cleaning methods. We cannot accept responsibility for damage caused by pre-existing defects, poor-quality materials, incorrect installation, deterioration, wear and tear, or surfaces unsuitable for standard cleaning products.",
  },
  {
    title: "Standard Cleaning Services",
    body: "Cleaning times and results vary depending on the size and condition of the property. Where a property is particularly dirty, neglected or requires work beyond a standard clean, we may recommend additional cleaning time or an additional fee with the customer's agreement.",
  },
  {
    title: "End of Tenancy Cleaning",
    body: "End of tenancy prices are based on the information supplied when booking, including property size and condition. Our advertised end-of-tenancy service includes the oven, fridge/freezer, microwave and inside cupboards. A property that is substantially dirtier than described may require additional charges, discussed before significant additional work wherever reasonably possible. An end-of-tenancy clean does not guarantee the return of a tenancy deposit, as landlords and letting agents may assess matters outside the scope of cleaning.",
  },
  {
    title: "Stains, Limescale & Permanent Marks",
    body: "We will make reasonable efforts to remove dirt, stains, limescale and other marks. Some staining, discolouration, mould, limescale, grease and odours may be permanent or require specialist treatment. We will not use aggressive methods that could risk damaging a surface simply to achieve a particular result.",
  },
  {
    title: "Breakages & Damage",
    body: "We take reasonable care when cleaning. If we accidentally cause damage, please notify us as soon as possible so the matter can be assessed and resolved fairly where appropriate. We cannot accept responsibility for items that are already damaged, unstable, defective, poorly maintained or particularly fragile.",
  },
  {
    title: "Valuables & Personal Belongings",
    body: "Customers should secure cash, jewellery, important documents and valuable or sentimental belongings before our arrival. Particularly valuable or fragile items should be stored safely away from areas being cleaned.",
  },
  {
    title: "Pets",
    body: "We are happy to work in homes with pets. Customers must ensure pets are safe and cannot interfere with equipment or prevent the service being carried out safely. Please tell us about pets before the first clean.",
  },
  {
    title: "Health, Safety & Access",
    body: "We reserve the right to refuse or stop work where a property presents a serious health or safety risk, including unsafe working conditions, excessive animal waste, sharps or hazardous materials, severe infestations, unsafe electrical equipment, structural hazards or substances requiring specialist treatment.",
  },
  {
    title: "Customer Belongings",
    body: "Customers should ensure floors, surfaces and areas to be cleaned are reasonably accessible. We are not responsible for cleaning areas that cannot be safely accessed due to clutter or belongings. We will not move heavy furniture or appliances unless agreed beforehand.",
  },
  {
    title: "Complaints & Re-cleans",
    body: "If you are unhappy with any aspect of the clean, please contact Five Point Cleaning within 24 hours of completion and provide details of the issue. Where appropriate, we may offer a reasonable opportunity to return and rectify the specific cleaning issue. We cannot accept responsibility for issues caused by other people entering or using the property after the clean.",
  },
  {
    title: "Payment",
    body: "The 50% deposit must be paid to secure the booking. The remaining 50% balance is due immediately after the clean. Payment can be made by bank transfer or cash. Failure to make payment may result in future bookings being suspended until outstanding balances are settled.",
  },
  {
    title: "Pricing",
    body: "Quotes are based on the information provided at the time of booking. If the requirements of the property differ substantially from the information provided, Five Point Cleaning reserves the right to revise the price. Any significant additional charge will be discussed before additional work is undertaken wherever reasonably possible.",
  },
  {
    title: "Photographs",
    body: "Where necessary, Five Point Cleaning may take photographs of cleaning results or areas requiring additional work for business records. We will not publish photographs containing identifiable personal information or private belongings without the customer's permission.",
  },
  {
    title: "Right to Refuse Service",
    body: "We reserve the right to refuse or terminate a service where there is abusive, threatening, discriminatory or inappropriate behaviour towards our cleaners, or where the property conditions place our staff at unreasonable risk.",
  },
  {
    title: "Agreement",
    body: "By making a booking and paying the deposit, the customer confirms that they have read, understood and agreed to these Terms & Conditions. These Terms & Conditions may be updated from time to time.",
  },
];
